<template>
    <simple-modal :show="show" @close="closeModal()"
                  title="Inspection Areas - Drag To Reorder">
        <template v-if="!loading">
            <draggable :list="areas"
                       class="gap-1"
                       :options="{animation: 100, handle: '.drag-handle'}" :element="'div'"
                       @change="updateAreaSequence">
                <div v-for="(area, index) in areas"
                     :key="area.id">
                    <div class="flex items-center gap-x-2 px-2 py-1 rounded-md drag-handle " :class="index % 2 === 0 ? 'bg-gray-100' : ''">
                        <div class="text-center">
                            <span class="checklist-set-item-bold">#{{ area.sequence_number }}</span>
                        </div>
                        <span>{{ area.name }}</span>
                    </div>
                </div>
            </draggable>

            <div class="flex justify-end w-full pt-4">
                <secondary-button @click.prevent="save()">
                    Reorder Areas
                </secondary-button>
            </div>
        </template>

        <template v-if="loading">
            <div class="text-gray-500 flex justify-center items-center py-20">
                <icon-refresh class="h-4 w-4 animate-spin text-indigo-600"/> &nbsp;Loading Areas...
            </div>
        </template>
    </simple-modal>
</template>

<script>
export default {
    name: "InspectionChecklistAreasSortingModal",

    props: ["inspection", "show"],

    data () {
        return {
            areas: null,
            loading: false,
        };
    },

    watch: {
        inspectionAreas (newValue) {
            this.areas = newValue.areas;
        },

        show (newValue) {
            if (newValue) {
                this.automaticallyReorderAreas();
            }
        }
    },

    methods: {
        automaticallyReorderAreas () {
            this.loading = true;
            App.post(`/inspections/${this.inspection.id}/areas/automatic-reorder`, new AppForm({}))
            .then(response => {
                this.areas = response;
                this.$emit("areas-sequence-changed");
                this.loading = false;
            }).catch(error => {
                this.loading = false;
                toastr.error("Error reordering areas. " + error.message);
            });
        },

        setAreasSequenceFromIndex () {
            this.areas.map((area, index) => {
                area.sequence_number = index + 1;
            });
        },

        updateAreaSequence () {
            this.setAreasSequenceFromIndex();

            let updatedAreas = this.areas.map(area => {
                return {"id": area.id, "sequence_number": area.sequence_number};
            });

            App.patch("/inspections/" + this.inspection.id + "/areas/order", new AppForm({
                "updatedAreas": updatedAreas
            }));
        },

        save () {
            this.updateAreaSequence();
            this.$emit("areas-sequence-changed");
            this.closeModal();
        },

        closeModal () {
            this.$emit("close");
        },
    },
};
</script>
